<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-6 col-sm-6 col-md-6">
        <div v-if="loading" class="loader">Loading...</div>
        <form @submit.prevent="submit" >
          <div class="form-group" v-if="errors.length" >
            <ul class="list-group">
              <li class="list-group-item list-group-item-danger" v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
          </div>
          <div class="form-group input-group-sm">
            <label >Nazwa sklepu</label>
            <input class="form-control" v-model="form.storeName"/>
          </div>
          <div class="form-group input-group-sm">
            <label >Wybierz bazowy sklep</label>
            <select class="form-control" v-model="form.baseStoreId">
              <option v-for="option in stores" :key="option.id" v-bind:value="option.id">
                {{ option.name }}
              </option>
            </select>
          </div>
          <div class="form-group input-group-sm">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="defaultCheck1" v-model="form.copyPrices">
              <label for="defaultCheck1">
                Kopiuj ceny ze sklepu bazowego
              </label>
            </div>
          </div>
          <input class="btn btn-success torre-btn btn-sm mr-2" type="submit" value="Zapisz">
          <router-link class="btn btn-secondary btn-sm" :to="{ name: 'stores' }">Anuluj</router-link>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import userService from '@/service/userService'
import axios from 'axios'
import validator from 'validator'
import un from 'underscore'
import appConfig from '@/service/config'
import flashService from '@/service/flashService'
import MainPresenter from "@/service/MainPresenter"

const mainPresenter = new MainPresenter();

export default {
  name: 'StoresNew',
  data: function () {
    return {
      pageable: appConfig.pageableMainParams,
      loading: false,
      errors: [],
      stores: [{
        id: -1,
        name: "wybierz"
      }],
      form: {
        storeName: '',
        baseStoreId: -1,
        copyPrices: false
      }
    }
  },
  methods: {
    validate () {
      var err = []
      if (validator.isEmpty(this.form.storeName)) {
        err.push('Podaj nazwe')
      }
      if (this.form.baseStoreId === -1) {
        err.push('Wybierz sklep')
      }
      return err
    },
    loadStores() {
      this.pageable.sort = "name,asc"
      const req = axios({
        method: 'get',
        url: mainPresenter.getUrlForCommonData("/stores?sort=name", {}, this.pageable),
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
      req.then(res => {
        this.stores = un.union(this.stores, res.data._embedded.stores);
        this.$emit('dataChanged', {
          data: res.data
        });
      }).catch(_ => {
        console.log('blad categories')
      })
    },
    submit: function () {
      if (this.loading) {
        return false
      }
      this.errors = []
      var err = this.validate()
      if (err.length > 0) {
        this.errors = err
        return false
      }
      
      this.loading = true

      const req = axios({
        method: 'post',
        url: appConfig.baseUrl + '/stores',
        data: this.form,
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
      req.then(res => {
        console.log(res.data)
        flashService.add("msg",{
          type: "alert-success",
          text: "Zapisano sklep"
        });
        this.loading = false
        this.$router.push({name: 'stores'})
      }).catch(err => {
        this.loading = false
        this.errors = un.map(err.response.data.errors, item => {
          return item.defaultMessage
        })
      })
    }
  },
  created: function () {
    this.loadStores()
  }
}
</script>

<style scoped >

</style>



// WEBPACK FOOTER //
// src/components/stores/StoresNew.vue